import request from '@/common/js/request';

/**
 * 设施设备类型
 */
export const getType = (params) => {
    return request('/parameterType/list',{
        params,
        method: 'get'
    })
}
/**
 * 获取设施数据
 */
export const getFacilities = (params) => {
    return request('/installationInfo/list',{
        params,
        method: 'get'
    })
}

//获取地图设施数据
export const getMapFacilities = (params) => {
    return request('/app/installationInfo/map/list',{
        params,
        method: 'get'
    })
}

// 查询设施详情
export const getInsDetailById = (params) => {
    return request('/installationInfo/getById',{
        params,
        method: 'get'
    })
}

/**
 * 获取设备数据
 */
export const getEquipment = (params) => {
    return request('/deviceMessage/getListByInstallationId',{
        params,
        method: 'get'
    })
}